import { Component, OnInit, OnDestroy, Inject, LOCALE_ID, Injector } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { MenuItem, ConfirmationService, MessageService } from 'primeng/api'; import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { WidgetsService } from 'src/app/services/widgets.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
export interface Widget {
  id: number;
  uid: string;
  type: number;
  name: string;
  smart: number | null;
  store_id: number;
  tags: string;
  title: string;
  limit: number | null;
  assets_count: number | null;
  template: string | null;
  page_type?: string;
  url_display: string | null;
  created_at: string;
  updated_at: string;
  feed_type: string;
}
@Component({
  selector: 'app-widgets',
  templateUrl: './widgets.component.html',
  styleUrls: ['./widgets.component.scss']
})
export class WidgetsComponent implements OnInit, OnDestroy {

  displaySidebar: boolean = false;
  loading: boolean = false;
  totalRecords: number = 0;
  widgets: Widget[] = [];
  allWidgets: Widget[] = [];
  itemsButtons: MenuItem[] = [];
  searchTerm: string = '';
  selectedWidget: any;
  private destroy$ = new Subject<void>();
  displayAguarde: boolean = false;
  totalWidgets: number = 0;
  constructor(
    private widgetService: WidgetsService,
    private errorHandler: ErrorHandlerService,
    @Inject(LOCALE_ID) private locale: string,
    private messageService: MessageService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private injector: Injector
  ) {

  }
  filteredWidgets: Widget[] = [];
  feedTypeOptions = [
    { label: 'Manual', value: 'manual' },
    { label: 'Tags', value: 'tags' }
  ];
  selectedFeedType: string | null = null;
  loadWidgets(): void {
    // Exemplo: Simulação de dados para `widgets`
    this.widgets = [];
    // Inicializa o array filtrado com todos os dados
    this.filteredWidgets = [...this.widgets];
  }


  applyFeedTypeFilter(): void {
    if (this.selectedFeedType) {
      this.filteredWidgets = this.widgets.filter(widget => widget.feed_type === this.selectedFeedType);
    } else {
      // Se nenhum filtro estiver selecionado, mostre todos os widgets
      this.filteredWidgets = [...this.widgets];
    }
  }
  selectedDate: Date | null = null;
  clearFeedTypeFilter(): void {
    this.selectedFeedType = null;
    this.applyFeedTypeFilter();
  }
  selectedDateRange: Date[] | null = null;
  clearDateFilter(): void {
    this.selectedDateRange = null;
    this.filteredWidgets = [...this.widgets];
  }
  onDateFilterChange(dateRange: Date[]): void {
    this.selectedDateRange = dateRange;

    if (!this.selectedDateRange || this.selectedDateRange.length !== 2) {
      // Se o intervalo não estiver completo, não aplique o filtro
      this.filteredWidgets = [...this.widgets];
      return;
    }

    const [startDate, endDate] = this.selectedDateRange;

    // Ajuste o `endDate` para incluir o final do dia
    const adjustedEndDate = new Date(endDate);
    adjustedEndDate.setHours(23, 59, 59, 999);  // Define o final do dia

    // Aplique o filtro para incluir widgets cuja data `created_at` esteja dentro do intervalo
    this.filteredWidgets = this.widgets.filter(widget => {
      const widgetDate = new Date(widget.created_at);
      return widgetDate >= startDate && widgetDate <= adjustedEndDate;
    });
  }
  totalPrints?: number;
  ngOnInit(): void {
    this.loadWidgets();
    //this.displayAguarde = true;
    this.loading = true;
    // Cache-first com ETag (src/app/core/http-cache).
    const widgetsResource = this.widgetService.getWidgetsRevalidated();

    toObservable(widgetsResource.data, { injector: this.injector }).pipe(
      filter((res): res is Widget[] => res !== null),
      takeUntil(this.destroy$)
    ).subscribe(res => {
        this.allWidgets = res;
        this.widgets = res;
        this.filteredWidgets = [...this.widgets];
        this.totalRecords = res.length; // Atualiza o total de registros
        this.loading = false;

        // Calcula a soma de todos os assets_count de cada widget
        this.totalWidgets = res.reduce((acc, widget) => acc + (widget.assets_count || 0), 0);
    });

    toObservable(widgetsResource.error, { injector: this.injector }).pipe(
      filter((err): err is any => err !== null),
      takeUntil(this.destroy$)
    ).subscribe(error => {
        this.loading = false;
        this.displayAguarde = false;
        this.errorHandler.handle(error);
    });

    const printEventsResource = this.widgetService.getPrintEventsRevalidated();

    toObservable(printEventsResource.data, { injector: this.injector }).pipe(
      filter((res): res is any => res !== null),
      takeUntil(this.destroy$)
    ).subscribe(res => {
        this.totalPrints = res.prints;
    });

    toObservable(printEventsResource.error, { injector: this.injector }).pipe(
      filter((err): err is any => err !== null),
      takeUntil(this.destroy$)
    ).subscribe(err => {
        this.loading = false;
    });


  }

  selectedPageTypeFilter: string | null = null; // Filtro por Tipo de Página
  selectedTemplateFilter: string | null = null; // Filtro por Template
  pageTypeOptions = [
    { label: 'Produtos', value: 'produtos' },
    { label: 'Coleções', value: 'colecoes' },
    { label: 'Artigos', value: 'artigos' },
    { label: 'Homepage', value: 'homepage' },
    { label: 'Outras', value: 'outras' }
  ];
  templateOptions = [
    { label: 'Carousel', value: 'carousel' },
    { label: 'Grid', value: 'grid' },
    { label: 'Discover', value: 'discover' },
    { label: 'Iframe', value: 'iframe' },
    { label: 'Inline', value: 'inline' },
    { label: 'Popup', value: 'popup' },
    { label: 'Stories', value: 'stories' }
  ];
  applyFilter() {
    this.filteredWidgets = this.allWidgets.filter(widget => {
      return (
        (!this.searchTerm ||
          (widget.title?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
            (widget.url_display ?? '').toLowerCase().includes(this.searchTerm.toLowerCase()))) &&
        (!this.selectedPageTypeFilter || widget['page_type'] === this.selectedPageTypeFilter) &&
        (!this.selectedTemplateFilter || widget.template === this.selectedTemplateFilter)
      );
    });
  }

  clearFilters() {
    this.searchTerm = '';
    this.selectedPageTypeFilter = null;
    this.selectedTemplateFilter = null;
    this.applyFilter();
  }
  // Define cores para os tipos de página
  getPageTypeSeverity(pageType: string): string {
    switch (pageType) {
      case 'produtos': return 'success';  // Verde
      case 'colecoes': return 'info';     // Azul
      case 'artigos': return 'warning';   // Amarelo
      case 'homepage': return 'contrast';  // Destaque
      case 'outras': return 'danger';     // Vermelho
      default: return 'secondary';        // Cinza
    }
  }

  // Define rótulos legíveis para os tipos de página
  getPageTypeLabel(pageType: string): string {
    const option = this.pageTypeOptions.find(opt => opt.value === pageType);
    return option ? option.label : '';
  }

  // Define cores para os templates
  getTemplateSeverity(template: string): string {
    switch (template) {
      case 'carousel': return 'primary';  // Azul
      case 'grid': return 'success';      // Verde
      case 'iframe': return 'warning';    // Amarelo
      case 'inline': return 'info';       // Azul claro
      case 'stories': return 'danger';    // Vermelho
      case 'popup': return 'help';    // Vermelho
      default: return 'secondary';        // Cinza
    }
  }

  // Define rótulos legíveis para os templates
  getTemplateLabel(template: string): string {
    const option = this.templateOptions.find(opt => opt.value === template);
    return option ? option.label : '';
  }
  clearPageTypeFilter() {
    this.selectedPageTypeFilter = null;
    this.applyFilter();
  }
  clearTemplateFilter() {
    this.selectedTemplateFilter = null;
    this.applyFilter();
  }
  




  getActionMenu(widget: any) {
    return [
      //{ label: 'Ver widget', icon: 'pi pi-eye', command: () => this.editWidgets(widget.uid) },
      { label: 'Editar', icon: 'pi pi-file-edit', command: () => this.editWidgets(widget.uid) },
      { label: 'Embed HTML', icon: 'pi pi-file-edit', command: () => this.editWidgets(widget.uid, true) },
      { label: 'Deletar', icon: 'pi pi-trash', command: () => this.deleteSlick(widget.id) },
    ];
  }
  editWidgets(widget_id: any, selectEmbedTab: boolean = false) {
    // Navegue para a rota com um parâmetro adicional indicando para selecionar a aba "Embedding"
    this.router.navigate(['/edit_widgets', widget_id], { queryParams: { embed: selectEmbedTab } });
  }
  deleteSlick(widget_id: any) {
    this.confirmationService.confirm({
      message: 'Você realmente deseja remover este widget?',
      header: 'Confirmação de Exclusão',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.displayAguarde = true;
        this.confirmDeletion(widget_id);
      },
      reject: () => {
      }
    });
  }
  confirmDeletion(widget_id: any) {
    this.widgetService.deleteWidgets(widget_id).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: Widget[]) => {
        this.widgets = this.widgets.filter(widget => widget.id !== widget_id);
        this.filteredWidgets = this.filteredWidgets.filter(widget => widget.id !== widget_id);
        this.totalRecords = this.widgets.length; // Atualiza o total de registros
        this.displayAguarde = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Widget Removido',
          detail: 'O Widget foi removido com sucesso!'
        });
      },
      error: (error) => {
        this.displayAguarde = false;
        let message = '';
        if (error.status === 400 || error.status === 403 || error.status === 401) {
          message = error.error.message;
        }  else {
          message = error.error.message;
        }
        this.errorHandler.handle(error, message);
        if (message) {
          this.showErrorDialog(message);
        }
      }
    });
  }
  showErrorDialog(message: string) {
    this.messageService.add({
      severity: 'error',
      summary: 'Erro',
      detail: message,
      icon: 'pi pi-times'
    });
  }
  // onFilterSlicks(event: any) {
  //   const searchValue = event.target.value.toLowerCase();

  //   // Filtrar widgets com base no nome ou na data formatada
  //   this.widgets = this.allWidgets.filter((widget: Widget) => {
  //     // Filtrar por name (caso não seja nulo ou indefinido)
  //     const matchesName = widget.name ? widget.name.toLowerCase().includes(searchValue) : false;

  //     // Filtrar por created_at
  //     const formattedDate = this.formatDate(widget.created_at);
  //     const matchesDate = formattedDate.includes(searchValue);

  //     // Retorna true se alguma das condições acima for satisfeita
  //     return matchesName || matchesDate;
  //   });

  //   this.totalRecords = this.widgets.length; // Atualizar a contagem de registros filtrados
  // }
  onFilterSlicks(event: Event) {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase().trim();
  
    this.filteredWidgets = this.allWidgets.filter(widget => {
      return (
        (!searchTerm || 
         (widget.title && widget.title.toLowerCase().includes(searchTerm)) ||
         (widget.url_display && widget.url_display.toLowerCase().includes(searchTerm)))
      ) &&
      (!this.selectedPageTypeFilter || widget.page_type === this.selectedPageTypeFilter) &&
      (!this.selectedTemplateFilter || widget.template === this.selectedTemplateFilter);
    });
  }
  formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('pt-BR').format(date);
  }
  openSidebar() {
    //
    this.router.navigate(['/create_widget']);
    //this.displaySidebar = true;
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
